import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Video } from '@grandvisionhq/content';
import { generateConditionalClassNames } from '../utils/utils.js';

var CmsRowVideo = ({ component  })=>{
    const { coverImage  } = component.getModels();
    const _ref = component.getParameters(), { videoUrl , document , horizontalAlignment , verticalAlignment  } = _ref, cssStyles = swcHelpers.objectWithoutProperties(_ref, [
        "videoUrl",
        "document",
        "horizontalAlignment",
        "verticalAlignment"
    ]);
    if (!videoUrl) {
        return null;
    }
    const filteredStyles = Object.fromEntries(Object.entries(cssStyles).filter(([_, value])=>value !== ''
    ));
    const rowVideoClassName = generateConditionalClassNames('br-row-video', {
        horizontalAlignment,
        verticalAlignment
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: rowVideoClassName,
        "data-t": "br-row-video",
        style: filteredStyles
    }, /*#__PURE__*/ React.createElement(Video, {
        videoUrl: videoUrl,
        coverImage: coverImage
    }));
};

export { CmsRowVideo, CmsRowVideo as default };
//# sourceMappingURL=RowVideo.js.map
